import store from '../../../store/configureStore';

import AirQualityDataItem from './AirQualityDataItem';
import MapProperties from '../../map/Properties';

let airData = false;

export default class AirQualityData {
  master_dataset = new Map();
  latest_dataset = new Map();
  master_dataset_in_view = new Map();
  latest_dataset_in_view = new Map();
  available_parameters = new Set();
  sensed_times_set = new Set();
  earliest_sensed = {};
  latest_sensed = {};
  location_set = {
    lat: new Set(),
    lng: new Set()
  };
  currentlyLoadingSources = {};
  isReadyForRender = true;
  currentView = new MapProperties();
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
  initialize() {
    if (store) {
      store.subscribe(AirQualityData.onMoveMap);
    }
  }
  addNewDataItem(dataObj) {
    if ((dataObj.isValid) && (dataObj.isValid())) {
      this.master_dataset.set(dataObj.uid, dataObj);
      if ((this.location_set.lat.has(dataObj.LOCATION.lat))
        && ((this.location_set.lng.has(dataObj.LOCATION.lng)))) {
        (Array.from(this.latest_dataset)).map(([key, aqdi]) => {
          if ((aqdi.LOCATION.lat === dataObj.LOCATION.lat)
            && (aqdi.LOCATION.lng === dataObj.LOCATION.lng)) {

            if (new Date(aqdi.SENSED_AT).getTime() < new Date(dataObj.SENSED_AT).getTime()) {
              this.latest_dataset.delete(key);
              this.latest_dataset.set(dataObj.uid, dataObj);
            }
          }
        });
      } else {
        this.location_set.lat.add(dataObj.LOCATION.lat);
        this.location_set.lng.add(dataObj.LOCATION.lng);
        this.latest_dataset.set(dataObj.uid, dataObj);
      }
      (Object.entries(AirQualityDataItem.PARAMETERS)).map(([key, value]) => {
        if ((dataObj["MEASUREMENTS"]) && (dataObj["MEASUREMENTS"][key])) {
          this.available_parameters.add(key);
        }
      });
      this.sensed_times_set.add(dataObj.SENSED_AT);
      if (this.earliest_sensed.SENSED_AT === undefined) {
        this.earliest_sensed = dataObj;
      }
      if ((this.earliest_sensed) && (this.earliest_sensed.SENSED_AT)
        && (new Date(this.earliest_sensed.SENSED_AT).getTime() > new Date(dataObj.SENSED_AT).getTime())) {
        this.earliest_sensed = dataObj;
      }
      if (this.latest_sensed.SENSED_AT === undefined) {
        this.latest_sensed = dataObj;
      }
      if ((this.latest_sensed) && (this.latest_sensed.SENSED_AT)
        && (new Date(this.latest_sensed.SENSED_AT).getTime() < new Date(dataObj.SENSED_AT).getTime())) {
        this.latest_sensed = dataObj;
      }
    }
  }
  lockRender(id) {
    let currentlyLoadingSources = Object.assign({}, this.currentlyLoadingSources, {
      [id]: {
        loading: true,
        loaded: false
      }
    });
    let isReadyForRender = false;
    Object.assign(this, {
      currentlyLoadingSources,
      isReadyForRender
    });
  }
  unlockRender(id) {
    let currentlyLoadingSources = Object.assign({}, this.currentlyLoadingSources, {
      [id]: {
        loading: false,
        loaded: true
      }
    });
    Object.assign(this, {
      currentlyLoadingSources
    });
    let unlock = (Object.entries(this.currentlyLoadingSources)).map(([key, value]) => {
      if ((value.loading === false) && (value.loaded === true)) {
        return true;
      } else {
        return false;
      }
    }).reduce((result, intermittentResult) => {
      return (result && intermittentResult);
    }, true);
    if (unlock) {
      currentlyLoadingSources = {};
      let isReadyForRender = true;
      Object.assign(this, {
        currentlyLoadingSources,
        isReadyForRender
      });
    }
  }
  updateCurrentView(view) {
    let master_dataset_in_view = new Map();
    let latest_dataset_in_view = new Map();
    let north_latitude = view.view.bounds._northEast.lat;
    let south_latitude = view.view.bounds._southWest.lat;
    let west_longitude = view.view.bounds._southWest.lng;
    let east_longitude = view.view.bounds._northEast.lng;
    (Array.from(this.master_dataset)).map(([id, aqdi]) => {
      if ((aqdi.LOCATION.lng >= west_longitude) && (aqdi.LOCATION.lng <= east_longitude)
        && (aqdi.LOCATION.lat >= south_latitude) && (aqdi.LOCATION.lat <= north_latitude)) {
        master_dataset_in_view.set(id, aqdi);
      }
    });
    (Array.from(this.latest_dataset)).map(([id, aqdi]) => {
      if ((aqdi.LOCATION.lng >= west_longitude) && (aqdi.LOCATION.lng <= east_longitude)
        && (aqdi.LOCATION.lat >= south_latitude) && (aqdi.LOCATION.lat <= north_latitude)) {
        latest_dataset_in_view.set(id, aqdi);
      }
    });
    Object.assign(this, {
      currentView: view,
      master_dataset_in_view,
      latest_dataset_in_view
    });
  }
  static get ACTIONS() {
    return {
      ADD_AIR_QUALITY_DATA_ITEMS: 'ADD_AIR_QUALITY_DATA_ITEMS',
      LOCK_AIR_QUALITY_RENDERING: 'LOCK_AIR_QUALITY_RENDERING',
      UNLOCK_AIR_QUALITY_RENDERING: 'UNLOCK_AIR_QUALITY_RENDERING',
      FILTER_ITEMS_IN_VIEW: 'FILTER_ITEMS_IN_VIEW',
    };
  }
  static addDataItems(data) {
    store.dispatch({
      type: AirQualityData.ACTIONS.ADD_AIR_QUALITY_DATA_ITEMS,
      data: data
    });
  }
  static onMoveMap() {
    let currentView = (store.getState()).map;
    let airQuality = (store.getState()).airQuality;
    let aqData = new AirQualityData(airQuality);
    if ((airQuality) && (airQuality.currentView)
      && (currentView)
      && (airQuality.currentView.view !== currentView.view || airData === false)
      && (aqData.master_dataset.size > 0)
      && (airQuality.isReadyForRender)) {
      airData = true;
      aqData.updateCurrentView(currentView);
      let markers = (Array.from(aqData.latest_dataset_in_view)).map(([id, aqdi]) => {
        return aqdi.getColourCodedMarkers();
      });
      store.dispatch({
        type: MapProperties.ACTIONS.ADD_MARKERS,
        newState: aqData,
        markers,
        component_key: 'air'
      });
    }
  }
  static reducer(state = {}, action) {
    switch (action.type) {
      case AirQualityData.ACTIONS.ADD_AIR_QUALITY_DATA_ITEMS: {
        let aqData = new AirQualityData(state);
        if ((action.data) && (action.data.length > 0)) {
          action.data.map((aqdi) => {
            aqData.addNewDataItem(aqdi);
          });
        }
        return aqData;
      }
      case AirQualityData.ACTIONS.LOCK_AIR_QUALITY_RENDERING: {
        let aqData = new AirQualityData(state);
        aqData.lockRender(action.id);
        return aqData;
      }
      case AirQualityData.ACTIONS.UNLOCK_AIR_QUALITY_RENDERING: {
        let aqData = new AirQualityData(state);
        aqData.unlockRender(action.id);
        return aqData;
      }
      case MapProperties.ACTIONS.ADD_MARKERS: {
        if (action.component_key === "air")
          return action.newState;
        return state;
      }
      default: {
        return state;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/data/airQuality/index.js